module.exports = __webpack_public_path__ + "static/media/icono-recursos.783e47c0.svg";